import { tr as __tr, useLocale as __useLocale } from "../../i18n/runtime";
import React from 'react';
import TransportSearchForm from './TransportSearchForm';
export default function BusBookingForm() {
  __useLocale();
  return <TransportSearchForm kind="bus" />;
}
